var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    rx: 20,
    fill: "#FAEED3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0005 65.5H36.0005C26.7605 65.5 25.0405 61.2 24.6005 57.02L23.1005 41C22.8805 38.9 22.8205 35.8 24.9005 33.48C26.7005 31.48 29.6805 30.52 34.0005 30.52H54.0005C58.3405 30.52 61.3205 31.5 63.1005 33.48C65.1805 35.8 65.1205 38.9 64.9005 41.02L63.4005 57C62.9605 61.2 61.2405 65.5 52.0005 65.5ZM34.0005 33.5C30.6205 33.5 28.3005 34.16 27.1205 35.48C26.1405 36.56 25.8205 38.22 26.0805 40.7L27.5805 56.72C27.9205 59.88 28.7805 62.5 36.0005 62.5H52.0005C59.2005 62.5 60.0805 59.88 60.4205 56.7L61.9205 40.72C62.1805 38.22 61.8605 36.56 60.8805 35.48C59.7005 34.16 57.3805 33.5 54.0005 33.5H34.0005Z",
    fill: "#EDA600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52 33.5C51.18 33.5 50.5 32.82 50.5 32V30.4C50.5 26.84 50.5 25.5 45.6 25.5H42.4C37.5 25.5 37.5 26.84 37.5 30.4V32C37.5 32.82 36.82 33.5 36 33.5C35.18 33.5 34.5 32.82 34.5 32V30.4C34.5 26.88 34.5 22.5 42.4 22.5H45.6C53.5 22.5 53.5 26.88 53.5 30.4V32C53.5 32.82 52.82 33.5 52 33.5Z",
    fill: "#EDA600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 53.5C38.5 53.5 38.5 50.1 38.5 48.06V46C38.5 43.18 39.18 42.5 42 42.5H46C48.82 42.5 49.5 43.18 49.5 46V48C49.5 50.08 49.5 53.5 44 53.5ZM41.5 45.5C41.5 45.66 41.5 45.84 41.5 46V48.06C41.5 50.12 41.5 50.5 44 50.5C46.5 50.5 46.5 50.18 46.5 48.04V46C46.5 45.84 46.5 45.66 46.5 45.5C46.34 45.5 46.16 45.5 46 45.5H42C41.84 45.5 41.66 45.5 41.5 45.5Z",
    fill: "#EDA600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.999 49.54C47.259 49.54 46.599 48.98 46.519 48.22C46.419 47.4 46.999 46.64 47.819 46.54C53.099 45.88 58.159 43.88 62.419 40.78C63.079 40.28 64.019 40.44 64.519 41.12C64.999 41.78 64.859 42.72 64.179 43.22C59.499 46.62 53.979 48.8 48.179 49.54C48.119 49.54 48.059 49.54 47.999 49.54Z",
    fill: "#EDA600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9995 49.56C39.9395 49.56 39.8795 49.56 39.8195 49.56C34.3395 48.94 28.9995 46.9401 24.3795 43.7801C23.6995 43.3201 23.5195 42.3801 23.9795 41.7C24.4395 41.02 25.3795 40.84 26.0595 41.3C30.2795 44.18 35.1395 46 40.1395 46.58C40.9595 46.68 41.5595 47.42 41.4595 48.24C41.3995 49 40.7595 49.56 39.9995 49.56Z",
    fill: "#EDA600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.ab525b059057784d7455e66dbe2e74be.svg";
export { ForwardRef as ReactComponent };